module.exports = __webpack_public_path__ + "static/img/bottomglobal.72dfaf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bottomglobal.png
// module id = kQCU
// module chunks = 2